export default __webpack_public_path__ + "static/media/034-certificate.ab3f08da.svg";